/**
 * Shared mouse grab-scroll for horizontal rails — binds every
 * [data-plx-dragscroll]. The ticker's proven pattern, generalized:
 * pointer-capture drag (mouse only; touch stays native via touch-action),
 * dragstart blocked (children are often links/images whose native drag
 * would cancel the pointer stream), and a capture-phase click guard so a
 * scrub that ends on a link doesn't follow it.
 */
(function () {
  'use strict';

  function bind(rail) {
    var dragging = false;
    var travel = 0;
    var lastX = 0;

    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragging = true;
      travel = 0;
      lastX = e.clientX;
      try { rail.setPointerCapture(e.pointerId); } catch (err) { /* synthetic */ }
      rail.classList.add('is-grabbing');
    });
    rail.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      travel += Math.abs(e.clientX - lastX);
      rail.scrollLeft -= e.clientX - lastX;
      lastX = e.clientX;
    });
    rail.addEventListener('click', function (e) {
      if (travel > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    function release() {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove('is-grabbing');
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
  }

  function init() {
    var rails = document.querySelectorAll('[data-plx-dragscroll]');
    for (var i = 0; i < rails.length; i++) bind(rails[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
